// The message shown for a url that is not well formed.
export const c_InvalidSiteUrlText = 'Enter a valid url, such as https://example.com.';

// Whether text is a well-formed site url, before it is sent: no spaces, http or https (https is assumed when no
// scheme is given), and a host with a dot that does not start or end with one. Whether the site answers there is
// checked by the backend when the site is added, since a browser cannot ask another site.
export const is_valid_site_url = (text)=>{
	const trimmed = String(text).trim();
	if((trimmed.length === 0) || /\s/.test(trimmed)){
		return false;
	}

	const full_url = /^https?:\/\//i.test(trimmed) ? trimmed : 'https://' + trimmed;

	try {
		const parsed_url = new URL(full_url);
		const hostname = parsed_url.hostname;
		if((parsed_url.protocol !== 'https:') && (parsed_url.protocol !== 'http:')){
			return false;
		}

		return hostname.includes('.') && !hostname.startsWith('.') && !hostname.endsWith('.');
	}
	catch (error) {
		return false;
	}
};
